import React, { useEffect, useState } from 'react';
import config from 'src/config';
import classNames from 'classnames';
import NoImageAvailable from '../no-image-available/NoImageAvailable';

type SpeciesImageProps = {
    scientificName: string;
    alt?: string;
    width?: string;
    height?: string;
    className?: string;
    noImageText?: string;
};

export const SpeciesImage = ({
    scientificName,
    alt = 'Species image',
    width = '100px',
    height = '56.25px',
    className,
    noImageText = 'No image available',
}: SpeciesImageProps) => {
    const [hasImageError, setHasImageError] = useState(false);

    const imageUrl = `${config.cmsApiUrl}/species/${encodeURIComponent(scientificName)}/image?size=thumbnail`;

    useEffect(() => {
        setHasImageError(false);
    }, [scientificName]);

    if (hasImageError) {
        return <NoImageAvailable width={width} height={height} text={noImageText} className={className} />;
    }

    return (
        <img
            src={imageUrl}
            alt={alt}
            className={classNames('rounded-md object-cover', className)}
            style={{ width, height }}
            onError={() => setHasImageError(true)}
        />
    );
};

export default SpeciesImage;
